const en = {
  suTitle: 'Service users',
  suDescription:
    'Passengers with a durable provider relationship and persisted booking or trip history. Dates select platform passenger creation, not consent or first use. History is lifetime within the selected provider, service groups and current mapped areas; memberships and welfare eligibility are current, provider-local associations, not past entitlement or remaining allowance.',
  suDateBasis: 'Passenger created in the platform (PASSENGER_CREATED_AT)',
  suCurrentMembership: 'Current membership and eligibility association',
  suProviderLocal: 'Visible within this provider only',
  suCurrentServiceGroup: 'Current service-group area mapping',
  suCompletedServiceDate: 'Completed-evidence trip service date',
  suMeaningRegistration:
    'Registration cohort uses platform passenger record creation. It never clips lifetime service history or implies consent.',
  suMeaningRelation:
    'When this durable provider relationship was established; it may be much later than platform passenger creation.',
  suMeaningBooking:
    'Earliest creation of a persisted booking matching provider and selected history dimensions, regardless of later cancellation.',
  suMeaningGroups:
    'Active membership now within this row’s provider; not membership at registration or on past service dates.',
  suMeaningWelfare:
    'Currently visible active welfare association via current active membership for this provider only; not a historical grant or remaining entitlement.',
  suMeaningArea:
    'Area filters use today’s service-group area mappings for both row population and lifetime history, not immutable trip-area evidence.',
  suMeaningCompletion:
    'First/last service date among trips with completed evidence; scheduledStart or createdAt fallback. A cancelled/scheduled trip without completion evidence contributes no completed-service date.',
  suMeaningBookingCount:
    'Distinct persisted bookings in lifetime provider history, including cancelled records; multiple legs do not multiply bookings. With group/area filters, require a matching Trip; without them, booking-only records also count.',
  suMeaningTripCount:
    'Persisted trip legs in lifetime scoped history, including scheduled/cancelled/missed; current group memberships do not narrow trip history.',
  suMeaningCompletedCount:
    'Trip legs with completed evidence (COMPLETED/AWAITING_OVERAGE status or a TRIP COMPLETED event), counted once regardless of event multiplicity.',
  suStatus_ACTIVE: 'Active',
  suStatus_INACTIVE: 'Inactive',
  suStatus_SUSPENDED: 'Suspended',
  suFilter_passengerIds: 'Passenger IDs',
  suFilter_passengerStatuses: 'Passenger status',
  suFilter_passengerGroupIds: 'Current active passenger group IDs',
  suFilter_welfareServiceGroupIds: 'Current visible welfare service group IDs',
  suFilter_hasCompletedService: 'Has completed-evidence service',
  suSummaryRows: 'Provider–passenger rows',
  suSummaryPeople: 'Distinct passengers across providers',
  suSummaryBookings: 'Lifetime scoped bookings',
  suSummaryTrips: 'Lifetime scoped trips',
  suSummaryCompleted: 'Completed-evidence trips',
  suSummaryWithCompleted: 'Provider–passenger rows with completed service',
  suSourceProvider: 'Current provider master record.',
  suSourcePassenger:
    'Current platform passenger master; never restored from historical actor snapshots after erasure.',
  suSourceRegistration:
    'Passenger.createdAt: platform record creation, not application registration or consent.',
  suSourceRelation: 'Durable provider–passenger relation createdAt, independent of passenger creation.',
  suSourceBooking:
    'Persisted bookings of this provider/passenger across all time and statuses. Group/area filters require a matching Trip in that history dimension. Bookings are counted once even with multiple legs.',
  suSourceMembership:
    'Current ACTIVE passenger-group membership for this row’s provider at dataAsOf; not historical membership.',
  suSourceEligibility:
    'Current membership through provider-local eligibility associations to ACTIVE WELFARE service groups; no caps, allowance or hidden provider groups.',
  suSourceHistory:
    'Persisted trips of this provider/passenger, all statuses and lifetime, constrained by selected service groups and their CURRENT_SERVICE_GROUP area mapping.',
  suSourceCompletion:
    'Trips with COMPLETED/AWAITING_OVERAGE status or a persisted TRIP COMPLETED event; first/last use scheduledStart, falling back to Trip.createdAt, not completion-event time.',
  suEmptyNever: 'Required persisted value; zero counts mean no matching evidence.',
  suEmptyBooking: 'No matching persisted booking creation time.',
  suEmptyGroups:
    'Empty list means no current active visible association within this provider; report access is denied without passenger-view permission.',
  suEmptyCompleted:
    'No matching completed-evidence service; scheduled/cancelled trips do not invent first or last completed service.',
  suColumn_provider_id: 'Provider ID',
  suColumn_provider_code: 'Provider code',
  suColumn_provider_name: 'Provider name',
  suColumn_passenger_id: 'Passenger ID',
  suColumn_passenger_code: 'Passenger code',
  suColumn_passenger_name: 'Passenger name',
  suColumn_passenger_phone: 'Passenger phone',
  suColumn_passenger_status: 'Passenger status',
  suColumn_registered_at: 'Passenger created in platform at',
  suColumn_date_basis: 'Registration date basis',
  suColumn_provider_related_at: 'Provider relationship established at',
  suColumn_first_booking_at: 'First scoped booking created at',
  suColumn_passenger_group_ids: 'Current passenger group IDs',
  suColumn_passenger_group_names: 'Current passenger group names',
  suColumn_welfare_service_group_ids: 'Current welfare service group IDs',
  suColumn_welfare_service_group_names: 'Current welfare service group names',
  suColumn_group_evidence_basis: 'Group evidence basis',
  suColumn_group_visibility: 'Group visibility',
  suColumn_area_evidence_basis: 'History area evidence basis',
  suColumn_first_service_date: 'First completed-evidence service date',
  suColumn_last_service_date: 'Last completed-evidence service date',
  suColumn_service_history_basis: 'Service history basis',
  suColumn_booking_count: 'Lifetime scoped booking count',
  suColumn_trip_count: 'Lifetime scoped trip count',
  suColumn_completed_trip_count: 'Completed-evidence trip count',
};
const th: Record<keyof typeof en, string> = {
  suTitle: 'ผู้ใช้บริการ',
  suDescription:
    'ผู้โดยสารที่มีความสัมพันธ์ถาวรกับผู้ให้บริการและมีรายการจองหรือเที่ยวจริงในระบบ ช่วงวันที่เลือกวันที่สร้างผู้โดยสาร ไม่ใช่วันที่ยินยอมหรือใช้บริการครั้งแรก ประวัติครอบคลุมทุกช่วงเวลาตามผู้ให้บริการ กลุ่มบริการ และพื้นที่ที่ผูกกับกลุ่มบริการปัจจุบัน กลุ่มผู้โดยสารและความสัมพันธ์สิทธิสวัสดิการเป็นข้อมูลปัจจุบันของผู้ให้บริการนี้ ไม่ใช่สิทธิในอดีตหรือโควตาคงเหลือ',
  suDateBasis: 'วันที่สร้างผู้โดยสารในระบบ (PASSENGER_CREATED_AT)',
  suCurrentMembership: 'สมาชิกและความสัมพันธ์สิทธิปัจจุบัน',
  suProviderLocal: 'มองเห็นเฉพาะภายในผู้ให้บริการนี้',
  suCurrentServiceGroup: 'พื้นที่ที่ผูกกับกลุ่มบริการปัจจุบัน',
  suCompletedServiceDate: 'วันบริการของเที่ยวที่มีหลักฐานจบงาน',
  suMeaningRegistration: 'ช่วงวันที่ใช้วันสร้างระเบียนผู้โดยสารในระบบ ไม่จำกัดประวัติบริการทุกช่วงเวลาและไม่สื่อถึงการยินยอม',
  suMeaningRelation: 'วันที่เริ่มความสัมพันธ์ถาวรกับผู้ให้บริการนี้ อาจช้ากว่าวันสร้างผู้โดยสารในระบบมาก',
  suMeaningBooking: 'เวลาสร้างรายการจองจริงแรกตามผู้ให้บริการและขอบเขตประวัติที่เลือก แม้ยกเลิกภายหลัง',
  suMeaningGroups: 'สมาชิกที่ใช้งานปัจจุบันภายในผู้ให้บริการของแถว ไม่ใช่สมาชิก ณ วันสร้างระเบียนหรือวันบริการในอดีต',
  suMeaningWelfare:
    'ความสัมพันธ์สวัสดิการที่ใช้งานและมองเห็นปัจจุบันผ่านสมาชิกปัจจุบันของผู้ให้บริการนี้ ไม่ใช่สิทธิในอดีตหรือโควตาคงเหลือ',
  suMeaningArea: 'ตัวกรองพื้นที่ใช้พื้นที่ที่ผูกกับกลุ่มบริการปัจจุบันทั้งเลือกแถวและคำนวณประวัติ ไม่ใช่หลักฐานพื้นที่เที่ยวที่ตรึงไว้',
  suMeaningCompletion:
    'วันบริการแรกและล่าสุดเฉพาะเที่ยวที่มีหลักฐานจบงาน ใช้ scheduledStart หรือ createdAt หากไม่มีวันนัด เที่ยวยกเลิกหรือนัดที่ไม่มีหลักฐานจบงานไม่สร้างวันบริการจบงาน',
  suMeaningBookingCount:
    'รายการจองจริงไม่ซ้ำทุกช่วงเวลาของผู้ให้บริการ รวมรายการยกเลิก หลายขาไม่นับซ้ำ เมื่อกรองกลุ่มหรือพื้นที่ต้องมีเที่ยวตรงขอบเขต หากไม่กรองจะรวมรายการที่ไม่มีเที่ยวด้วย',
  suMeaningTripCount: 'ขาเที่ยวจริงทุกช่วงเวลาตามขอบเขต รวมเที่ยวที่นัด ยกเลิก และพลาดงาน สมาชิกกลุ่มปัจจุบันไม่จำกัดประวัติเที่ยว',
  suMeaningCompletedCount:
    'ขาเที่ยวที่มีหลักฐานจบงานจากสถานะ COMPLETED/AWAITING_OVERAGE หรือเหตุการณ์ TRIP COMPLETED นับครั้งเดียวแม้มีหลายเหตุการณ์',
  suStatus_ACTIVE: 'ใช้งาน',
  suStatus_INACTIVE: 'ไม่ใช้งาน',
  suStatus_SUSPENDED: 'ระงับใช้งาน',
  suFilter_passengerIds: 'รหัสอ้างอิงผู้โดยสาร',
  suFilter_passengerStatuses: 'สถานะผู้โดยสาร',
  suFilter_passengerGroupIds: 'รหัสกลุ่มผู้โดยสารที่ใช้งานปัจจุบัน',
  suFilter_welfareServiceGroupIds: 'รหัสกลุ่มสวัสดิการที่มองเห็นปัจจุบัน',
  suFilter_hasCompletedService: 'มีหลักฐานบริการที่จบงาน',
  suSummaryRows: 'แถวผู้ให้บริการ–ผู้โดยสาร',
  suSummaryPeople: 'ผู้โดยสารไม่ซ้ำข้ามผู้ให้บริการ',
  suSummaryBookings: 'รายการจองทุกช่วงเวลาตามขอบเขต',
  suSummaryTrips: 'เที่ยวทุกช่วงเวลาตามขอบเขต',
  suSummaryCompleted: 'เที่ยวที่มีหลักฐานจบงาน',
  suSummaryWithCompleted: 'แถวผู้ให้บริการ–ผู้โดยสารที่มีบริการจบงาน',
  suSourceProvider: 'ข้อมูลหลักผู้ให้บริการปัจจุบัน',
  suSourcePassenger: 'ข้อมูลหลักผู้โดยสารปัจจุบันในระบบ ไม่กู้ข้อมูลส่วนบุคคลจากประวัติผู้กระทำหลังลบบัญชี',
  suSourceRegistration: 'Passenger.createdAt คือวันที่สร้างระเบียน ไม่ใช่วันสมัครแอปหรือยินยอม',
  suSourceRelation: 'createdAt ของความสัมพันธ์ถาวรผู้ให้บริการ–ผู้โดยสาร แยกจากวันที่สร้างผู้โดยสาร',
  suSourceBooking:
    'รายการจองจริงของผู้ให้บริการและผู้โดยสารทุกช่วงเวลาและทุกสถานะ ตัวกรองกลุ่มหรือพื้นที่ต้องมีเที่ยวตรงขอบเขตประวัติ นับแต่ละรายการครั้งเดียวแม้มีหลายขา',
  suSourceMembership: 'สมาชิกกลุ่มผู้โดยสาร ACTIVE ปัจจุบันของผู้ให้บริการในแถว ณ เวลาข้อมูล ไม่ใช่สมาชิกในอดีต',
  suSourceEligibility:
    'สมาชิกปัจจุบันเชื่อมความสัมพันธ์สิทธิของผู้ให้บริการเดียวกันไปยังกลุ่มบริการ WELFARE ที่ ACTIVE ไม่แสดงเพดาน โควตา หรือกลุ่มของผู้ให้บริการอื่น',
  suSourceHistory:
    'เที่ยวจริงของผู้ให้บริการและผู้โดยสาร ทุกสถานะและทุกช่วงเวลา จำกัดตามกลุ่มบริการที่เลือกและพื้นที่ CURRENT_SERVICE_GROUP ที่ผูกปัจจุบัน',
  suSourceCompletion:
    'เที่ยวสถานะ COMPLETED/AWAITING_OVERAGE หรือมีเหตุการณ์ TRIP COMPLETED วันแรกและวันล่าสุดใช้ scheduledStart หรือ Trip.createdAt หากไม่มีวันนัด ไม่ใช่เวลาเหตุการณ์จบงาน',
  suEmptyNever: 'ค่าที่ต้องมีจากข้อมูลจริง จำนวนศูนย์หมายถึงไม่มีหลักฐานตรงขอบเขต',
  suEmptyBooking: 'ไม่มีเวลาสร้างรายการจองจริงที่ตรงขอบเขต',
  suEmptyGroups: 'รายการว่างหมายถึงไม่มีความสัมพันธ์ที่ใช้งานปัจจุบันและมองเห็นภายในผู้ให้บริการนี้ ผู้ไม่มีสิทธิ์ดูผู้โดยสารถูกปฏิเสธรายงาน',
  suEmptyCompleted: 'ไม่มีบริการที่มีหลักฐานจบงานตรงขอบเขต ไม่ใช้เที่ยวที่นัดหรือยกเลิกแทนวันบริการจบงานแรกและล่าสุด',
  suColumn_provider_id: 'รหัสอ้างอิงผู้ให้บริการ',
  suColumn_provider_code: 'รหัสผู้ให้บริการ',
  suColumn_provider_name: 'ชื่อผู้ให้บริการ',
  suColumn_passenger_id: 'รหัสอ้างอิงผู้โดยสาร',
  suColumn_passenger_code: 'รหัสผู้โดยสาร',
  suColumn_passenger_name: 'ชื่อผู้โดยสาร',
  suColumn_passenger_phone: 'โทรศัพท์ผู้โดยสาร',
  suColumn_passenger_status: 'สถานะผู้โดยสาร',
  suColumn_registered_at: 'วันที่สร้างผู้โดยสารในระบบ',
  suColumn_date_basis: 'ฐานวันที่สร้างผู้โดยสาร',
  suColumn_provider_related_at: 'วันที่เริ่มความสัมพันธ์กับผู้ให้บริการ',
  suColumn_first_booking_at: 'เวลาสร้างรายการจองแรกตามขอบเขต',
  suColumn_passenger_group_ids: 'รหัสกลุ่มผู้โดยสารปัจจุบัน',
  suColumn_passenger_group_names: 'ชื่อกลุ่มผู้โดยสารปัจจุบัน',
  suColumn_welfare_service_group_ids: 'รหัสกลุ่มสวัสดิการปัจจุบัน',
  suColumn_welfare_service_group_names: 'ชื่อกลุ่มสวัสดิการปัจจุบัน',
  suColumn_group_evidence_basis: 'ฐานหลักฐานกลุ่ม',
  suColumn_group_visibility: 'ขอบเขตการมองเห็นกลุ่ม',
  suColumn_area_evidence_basis: 'ฐานหลักฐานพื้นที่ประวัติ',
  suColumn_first_service_date: 'วันบริการแรกที่มีหลักฐานจบงาน',
  suColumn_last_service_date: 'วันบริการล่าสุดที่มีหลักฐานจบงาน',
  suColumn_service_history_basis: 'ฐานประวัติบริการ',
  suColumn_booking_count: 'จำนวนรายการจองทุกช่วงเวลาตามขอบเขต',
  suColumn_trip_count: 'จำนวนเที่ยวทุกช่วงเวลาตามขอบเขต',
  suColumn_completed_trip_count: 'จำนวนเที่ยวที่มีหลักฐานจบงาน',
};
export const serviceUsersTranslations = { th, en };
